import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { notificationsDTO } from '../gestion-jardin/gestion-messagarie/models/notificationsDTO';
import { environment } from '../../../../environments/environement';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
 baseUrl = environment.apiUrl;
 userId!:number|1;
 platformId:any;
  constructor( private http: HttpClient) { }

  getUserId(): void {
    const storedUserId = localStorage.getItem('userId');
    this.userId = storedUserId ? Number(storedUserId) : 1;

    if (isNaN(this.userId)) {
      console.error('Invalid user ID in localStorage');
      this.userId = 1;
    }
  }
  private getAuthHeaders(): { [header: string]: string } {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
    return {};
  }

    // Récupérer les notifications de l'utilisateur
    getUserNotifications(): Observable<notificationsDTO[]> {
      const userId = localStorage.getItem('userId');
      return this.http.get<notificationsDTO[]>(`${this.baseUrl}/notifications/user/${userId}`,
        { headers: this.getAuthHeaders() });
    }

    // Marquer une notification comme lue
    markAsRead(notificationId: number): Observable<void> {
      const userId = localStorage.getItem('userId');
      return this.http.put<void>(
        `${this.baseUrl}/notifications/${notificationId}/read?userId=${userId}`,
        {},
        { headers: this.getAuthHeaders() }
      );
    }

    // Marquer une notification comme non lue
    markAsUnread(notificationId: number): Observable<void> {
      const userId = localStorage.getItem('userId');
      return this.http.put<void>(
        `${this.baseUrl}/notifications/${notificationId}/unread?userId=${userId}`,
        {},
        { headers: this.getAuthHeaders() }
      );
    }

    // Marquer toutes les notifications comme lues
    markAllAsRead(): Observable<void> {
      const userId = localStorage.getItem('userId');
      return this.http.put<void>(
        `${this.baseUrl}/notifications/read-all?userId=${userId}`,
        {},
        { headers: this.getAuthHeaders() }
      );
    }
}

